import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialGroupLaboratoryFinanceByTrialGroupLaboratoryId: ITrialGroupLaboratoryFinanceLoadByTrialGroupLaboratoryIdActionCreator = (trialGroupLaboratoryId) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_TRIAL_GROUP_LABORATORY_ID,
            trialGroupLaboratoryId
        }
    },
    LoadTrialGroupLaboratoryFinanceById: ITrialGroupLaboratoryFinanceLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialGroupLaboratoryFinanceLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialGroupLaboratoryFinanceLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialGroupLaboratoryFinance: ITrialGroupLaboratoryFinanceSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialGroupLaboratoryFinanceSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialGroupLaboratoryFinanceSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialGroupLaboratoryFinance: ITrialGroupLaboratoryFinanceValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialGroupLaboratoryFinanceValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialGroupLaboratoryFinanceValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialGroupLaboratoryFinance: ITrialGroupLaboratoryFinanceCreateActionCreator = (trialGroupLaboratoryId) => {

        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_CREATE,
            trialGroupLaboratoryId
        }
    },
    CreateSuccess: ITrialGroupLaboratoryFinanceCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialGroupLaboratoryFinanceCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncTrialGroupLaboratoryFinance: ITrialGroupLaboratoryFinanceSyncActionCreator = (trialGroupLaboratoryId) => {

        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_SYNC,
            trialGroupLaboratoryId
        }
    },
    SyncSuccess: ITrialGroupLaboratoryFinanceSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: ITrialGroupLaboratoryFinanceSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialGroupLaboratoryFinanceClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialGroupLaboratoryFinanceFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYFINANCE_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_TRIAL_GROUP_LABORATORY_ID = "ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_TRIAL_GROUP_LABORATORY_ID",
    ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_ID = "ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_ID",
    ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_SUCCESS = "ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_SUCCESS",
    ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_FAILURE = "ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_FAILURE",

    ACTION_TRIALGROUPLABORATORYFINANCE_SAVE = "ACTION_TRIALGROUPLABORATORYFINANCE_SAVE",
    ACTION_TRIALGROUPLABORATORYFINANCE_SAVE_SUCCESS = "ACTION_TRIALGROUPLABORATORYFINANCE_SAVE_SUCCESS",
    ACTION_TRIALGROUPLABORATORYFINANCE_SAVE_FAILURE = "ACTION_TRIALGROUPLABORATORYFINANCE_SAVE_FAILURE",

    ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE = "ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE",
    ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE_SUCCESS = "ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE_SUCCESS",
    ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE_FAILURE = "ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE_FAILURE",

    ACTION_TRIALGROUPLABORATORYFINANCE_CREATE = "ACTION_TRIALGROUPLABORATORYFINANCE_CREATE",
    ACTION_TRIALGROUPLABORATORYFINANCE_CREATE_SUCCESS = "ACTION_TRIALGROUPLABORATORYFINANCE_CREATE_SUCCESS",
    ACTION_TRIALGROUPLABORATORYFINANCE_CREATE_FAILURE = "ACTION_TRIALGROUPLABORATORYFINANCE_CREATE_FAILURE",

    ACTION_TRIALGROUPLABORATORYFINANCE_SYNC = "ACTION_TRIALGROUPLABORATORYFINANCE_SYNC",
    ACTION_TRIALGROUPLABORATORYFINANCE_SYNC_SUCCESS = "ACTION_TRIALGROUPLABORATORYFINANCE_SYNC_SUCCESS",
    ACTION_TRIALGROUPLABORATORYFINANCE_SYNC_FAILURE = "ACTION_TRIALGROUPLABORATORYFINANCE_SYNC_FAILURE",

    ACTION_TRIALGROUPLABORATORYFINANCE_CLEAR = "ACTION_TRIALGROUPLABORATORYFINANCE_CLEAR",

    ACTION_TRIALGROUPLABORATORYFINANCE_FILTER = "ACTION_TRIALGROUPLABORATORYFINANCE_FILTER";

export interface ITrialGroupLaboratoryFinanceLoadByTrialGroupLaboratoryIdAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_TRIAL_GROUP_LABORATORY_ID";
    trialGroupLaboratoryId: number;
}

export interface ITrialGroupLaboratoryFinanceLoadByTrialGroupLaboratoryIdActionCreator {
    (trialGroupLaboratoryId: number): ITrialGroupLaboratoryFinanceLoadByTrialGroupLaboratoryIdAction;
}

export interface ITrialGroupLaboratoryFinanceLoadSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryFinance | Dtos.TrialGroupLaboratoryFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryFinanceLoadSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryFinance | Dtos.TrialGroupLaboratoryFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryFinanceLoadSuccessAction;
}

export interface ITrialGroupLaboratoryFinanceLoadFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryFinanceLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryFinanceLoadFailureAction;
}

export interface ITrialGroupLaboratoryFinanceLoadByIdAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_LOAD_BY_ID";
    id: number;
}

export interface ITrialGroupLaboratoryFinanceLoadByIdActionCreator {
    (id: number): ITrialGroupLaboratoryFinanceLoadByIdAction;
}

export interface ITrialGroupLaboratoryFinanceSaveAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_SAVE";
    formData: Dtos.TrialGroupLaboratoryFinance;

}

export interface ITrialGroupLaboratoryFinanceSaveActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryFinance
    ): ITrialGroupLaboratoryFinanceSaveAction;
}

export interface ITrialGroupLaboratoryFinanceSaveSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_SAVE_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryFinanceSaveSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryFinanceSaveSuccessAction;
}

export interface ITrialGroupLaboratoryFinanceSaveFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryFinanceSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryFinanceSaveFailureAction;
}

export interface ITrialGroupLaboratoryFinanceValidateAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE";
    formData: Dtos.TrialGroupLaboratoryFinance;

}

export interface ITrialGroupLaboratoryFinanceValidateActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryFinance
    ): ITrialGroupLaboratoryFinanceValidateAction;
}

export interface ITrialGroupLaboratoryFinanceValidateSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryFinanceValidateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryFinanceValidateSuccessAction;
}

export interface ITrialGroupLaboratoryFinanceValidateFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryFinanceValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryFinanceValidateFailureAction;
}

export interface ITrialGroupLaboratoryFinanceCreateAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_CREATE",
    trialGroupLaboratoryId: number
}

export interface ITrialGroupLaboratoryFinanceCreateActionCreator {
    (trialGroupLaboratoryId: number): ITrialGroupLaboratoryFinanceCreateAction
}

export interface ITrialGroupLaboratoryFinanceCreateSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_CREATE_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryFinance;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialGroupLaboratoryFinanceCreateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryFinance,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialGroupLaboratoryFinanceCreateSuccessAction;
}

export interface ITrialGroupLaboratoryFinanceCreateFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryFinanceCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryFinanceCreateFailureAction;
}

export interface ITrialGroupLaboratoryFinanceClearAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialGroupLaboratoryFinanceClearActionCreator {
    (propertiesToClear?: string[]): ITrialGroupLaboratoryFinanceClearAction;
}

export interface ITrialGroupLaboratoryFinanceFilterActionCreator {
    (formFilter: IFormFilter): ITrialGroupLaboratoryFinanceFilterAction;
}

export interface ITrialGroupLaboratoryFinanceFilterAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_FILTER";
    formFilter: IFormFilter;
}

export interface ITrialGroupLaboratoryFinanceSyncAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_SYNC",
    trialGroupLaboratoryId: number
}

export interface ITrialGroupLaboratoryFinanceSyncActionCreator {
    (trialGroupLaboratoryId: number): ITrialGroupLaboratoryFinanceSyncAction
}

export interface ITrialGroupLaboratoryFinanceSyncSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_SYNC_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryFinanceSyncSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryFinanceSyncSuccessAction;
}

export interface ITrialGroupLaboratoryFinanceSyncFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYFINANCE_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryFinanceSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryFinanceSyncFailureAction;
}

export type TrialGroupLaboratoryFinanceAction =
    ITrialGroupLaboratoryFinanceLoadByTrialGroupLaboratoryIdAction |
    ITrialGroupLaboratoryFinanceLoadByIdAction |
    ITrialGroupLaboratoryFinanceLoadFailureAction |
    ITrialGroupLaboratoryFinanceLoadSuccessAction |
    ITrialGroupLaboratoryFinanceSaveAction |
    ITrialGroupLaboratoryFinanceSaveSuccessAction |
    ITrialGroupLaboratoryFinanceSaveFailureAction |
    ITrialGroupLaboratoryFinanceValidateAction |
    ITrialGroupLaboratoryFinanceValidateSuccessAction |
    ITrialGroupLaboratoryFinanceValidateFailureAction |
    ITrialGroupLaboratoryFinanceCreateAction |
    ITrialGroupLaboratoryFinanceCreateSuccessAction |
    ITrialGroupLaboratoryFinanceCreateFailureAction |
    ITrialGroupLaboratoryFinanceSyncAction |
    ITrialGroupLaboratoryFinanceSyncSuccessAction |
    ITrialGroupLaboratoryFinanceSyncFailureAction |
    ITrialGroupLaboratoryFinanceClearAction | 
    ITrialGroupLaboratoryFinanceFilterAction;
